import { Page } from '@ui/themed';
import { t } from 'i18next';
import { useEnv } from '../../../context/env-context';
import { useHandlers, withPageProviders } from '../../../context/page-context';
import { ProductSearch } from '../../products/components/product-search';
import { useProductLookup } from '../../products/hooks/use-product-lookup';
import { UnusedSkuPrompt } from '../components/unused-sku-prompt';
import { DOCS_URLS, I18N_PAGE, PRICE_EDITOR_PATH } from '../constants';

export const PriceEditorPage = withPageProviders(
  ({ initialSearchTerm = '' }: { initialSearchTerm?: string }) => {
    const env = useEnv();
    const { navigationHandler } = useHandlers();

    const { searchTerm, debouncedTerm, setSearchTerm, results, isFetching, isError, refetch } =
      useProductLookup(initialSearchTerm);

    const openEditor = (sku: string) =>
      navigationHandler.navigate(`${PRICE_EDITOR_PATH}/${encodeURIComponent(sku)}`);

    return (
      <Page
        title={t(`${I18N_PAGE}.title`)}
        description={t(`${I18N_PAGE}.description`)}
        learnMoreUrl={DOCS_URLS.priceEditor}
      >
        <UnusedSkuPrompt term={debouncedTerm} results={results} onCreate={openEditor} />
        <ProductSearch
          searchTerm={searchTerm}
          debouncedTerm={debouncedTerm}
          results={results}
          isFetching={isFetching}
          isError={isError}
          onRetry={refetch}
          platform={env.connected_platform}
          onSearchTermChange={setSearchTerm}
          onSelectVariant={openEditor}
        />
      </Page>
    );
  },
);
